import React from 'react';
import { bottomBarPropTypes } from './BottomBarPropTypes';
import Icon from '@Theme/natucare/components/Icon/Icon';
import * as styles from './BottomBar.module.scss';
const renderIcons = (items, className) => /*#__PURE__*/React.createElement("div", {
  className: className
}, items.map((item, index) => {
  return item.icon && item.visible && /*#__PURE__*/React.createElement(Icon, {
    classname: styles.rootIcon,
    name: item.icon,
    key: index
  });
}));
const BottomBar = ({
  icons,
  interlinks,
  copyright
}) => {
  if (!interlinks) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, icons && /*#__PURE__*/React.createElement("div", {
    className: styles.rootIcons
  }, (icons === null || icons === void 0 ? void 0 : icons.shipping) && renderIcons(icons.shipping, styles.rootIconsShipping), (icons === null || icons === void 0 ? void 0 : icons.payment) && renderIcons(icons.payment, styles.rootIconsPayment)), /*#__PURE__*/React.createElement("div", {
    className: styles.rootMeta
  }, interlinks && /*#__PURE__*/React.createElement("div", {
    className: styles.rootMetaLinks,
    dangerouslySetInnerHTML: {
      __html: interlinks
    }
  }), copyright && /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: copyright
    }
  })));
};
export default BottomBar;